/* eslint-disable @nx/enforce-module-boundaries */
import { Location } from '@angular/common';
import { AfterViewInit, ApplicationRef, Component, NgZone, OnDestroy, OnInit, inject } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';

import { EnvironmentConfig } from '@frontend/oxygen/bma-env-config';
import { CmsService, ISystemConfig, PubSubService } from '@frontend/oxygen/core';
import decorateTick from '@frontend/oxygen/core-lib';
import { RxVirtualViewObserver } from '@frontend/vanilla/shared/virtual-view';
import { Subscription } from 'rxjs';

@Component({
    selector: 'root-app',
    templateUrl: './app.component.html',
    standalone: false,
    hostDirectives: [RxVirtualViewObserver],
})
export class RootComponent implements AfterViewInit, OnInit, OnDestroy {
    private readonly environment = inject(EnvironmentConfig).configuration;
    isHomePage: boolean = true;
    isProduction = this.environment.PRODUCTION;
    protected routeChangeListener: Subscription;

    constructor(
        protected pubsub: PubSubService,
        private applicationRef: ApplicationRef,
        private ngZone: NgZone,
        private pubSubService: PubSubService,
        private router: Router,
        private cmsService: CmsService,
        private location: Location,
    ) {
        decorateTick(this.applicationRef, this.ngZone, this.pubSubService, this.router);
    }

    ngOnInit(): void {
        this.checkHomeUrl();
        this.routeChangeListener = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart || event instanceof NavigationEnd) {
                if (!event.url.includes('en/sports') && !event.url.includes('http')) {
                    this.router.navigate([`/en/sports${event.url}`]);
                } else if (this.location.path().includes('en/sports/bet-filter') && !this.router.url.includes('en/sports/bet-filter')) {
                    this.location.replaceState(this.router.url);
                }
                this.checkHomeUrl();
            }
        });
    }

    checkHomeUrl() {
        const currentURL: string = this.router.url.split('?')[0];
        this.isHomePage = currentURL === '/en/sports' || currentURL === '/' || currentURL.indexOf('/home') > -1 ? true : false;
    }

    ngAfterViewInit(): void {
        this.cmsService.getSystemConfig().subscribe((config: ISystemConfig) => {
            const gamingEnabled = config.GamingEnabled || {};
            const { enabledGamingOverlay } = gamingEnabled;
            if (enabledGamingOverlay) {
                //  this.casinoPlatformLoaderService.loadCasinoPlatformModule(process.env.NODE_ENV, { disableCasinoLocalStorage: true });
            }
        });
    }

    ngOnDestroy(): void {
        this.routeChangeListener && this.routeChangeListener.unsubscribe();
    }
}
